var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaveOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 357.97 948.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #003c52;\n        opacity: .4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.09,910.17c-16.14-57.58,25.53-122.32,54.93-166.18,29.4-43.85-19.39-104.75-62.8-146.46-43.41-41.7-45.21-119.26-4.69-191.35,40.52-72.09,27.47-170.37-46.14-219.58C161.78,137.41,45.26,112.98,0,0L105.67,948.02l188.42-37.84Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveOne);
export default __webpack_public_path__ + "static/media/wave-one.b9bcc7c23cf70f575fe22a79b1e5ab99.svg";
export { ForwardRef as ReactComponent };